import { frontendURL } from 'dashboard/helper/URLHelper.js';
import MyQaIncidentsPage from './pages/MyQaIncidentsPage.vue';

// Standalone TOP-LEVEL route (NOT a child of qa.routes.js, whose parent path is
// qa-dashboard and whose leaves require QA permissions plain agents lack). meta
// grants every logged-in member: plain agents hold ['agent'], custom-role agents
// hold custom_role.permissions + ['custom_role'] (no 'agent' token), admins hold
// ['administrator'] — an empty/absent permissions array is DENY-ALL, not show-all.
const myQaRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/my-qa'),
      name: 'my_qa_incidents_index',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: MyQaIncidentsPage,
    },
  ],
};

export default myQaRoutes;
